(function(){
  var $=function(s,c){return (c||document).querySelector(s)}, $$=function(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s))};

  // galeria: flechas y miniaturas
  $$('.gal').forEach(function(g){
    var sl=$('.slides',g), th=$$('.thumbs button');
    function go(i){sl.scrollTo({left:i*sl.clientWidth,behavior:'smooth'})}
    function cur(){return Math.round(sl.scrollLeft/sl.clientWidth)}
    var p=$('.prev',g), n=$('.next',g), k=sl.children.length;
    if(p) p.onclick=function(){go((cur()-1+k)%k)};
    if(n) n.onclick=function(){go((cur()+1)%k)};
    th.forEach(function(b,i){b.onclick=function(){go(i)}});
    sl.addEventListener('scroll',function(){var c=cur();th.forEach(function(b,i){b.classList.toggle('on',i===c)})},{passive:true});
  });

  // packs: la seleccion se refleja en el beneficio y en la barra fija
  function pick(card){
    $$('.pack').forEach(function(c){c.classList.toggle('on',c===card)});
    var d=card.dataset;
    $$('[data-out=pack]').forEach(function(e){e.textContent=d.name});
    $$('[data-out=price]').forEach(function(e){e.textContent=d.price});
    $$('[data-out=unit]').forEach(function(e){e.textContent=d.unit});
  }
  $$('.pack').forEach(function(c){c.addEventListener('click',function(){pick(c)})});
  var first=$('.pack.on')||$('.pack'); if(first) pick(first);

  // tallas
  $$('.sizes').forEach(function(w){
    $$('button',w).forEach(function(b){b.onclick=function(){
      $$('button',w).forEach(function(x){x.classList.toggle('on',x===b)});
      $$('[data-out=size]').forEach(function(e){e.textContent=b.textContent});
    }});
  });

  // pestanas
  $$('[data-tabs]').forEach(function(w){
    var bs=$$('.tabs button',w), ps=$$('.tabpane',w);
    bs.forEach(function(b,i){b.onclick=function(){
      bs.forEach(function(x,j){x.classList.toggle('on',j===i)});
      ps.forEach(function(p,j){p.hidden=j!==i});
    }});
  });

  // fechas de entrega: hoy, despacho al siguiente dia habil, llegada de 3 a 6 dias habiles
  var M=['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic'];
  function addBiz(d,n){d=new Date(d);while(n>0){d.setDate(d.getDate()+1);if(d.getDay()!==0&&d.getDay()!==6)n--}return d}
  function f(d){return d.getDate()+' '+M[d.getMonth()]}
  var hoy=new Date();
  $$('[data-date=hoy]').forEach(function(e){e.textContent=f(hoy)});
  $$('[data-date=despacho]').forEach(function(e){e.textContent=f(addBiz(hoy,1))});
  $$('[data-date=llega]').forEach(function(e){var a=addBiz(hoy,3),b=addBiz(hoy,6);e.textContent=a.getMonth()===b.getMonth()?a.getDate()+' a '+f(b):f(a)+' a '+f(b)});

  // barra fija: aparece cuando la caja de compra sale de pantalla
  var st=$('.sticky'), buy=$('#comprar');
  if(st&&buy&&'IntersectionObserver' in window){
    new IntersectionObserver(function(e){st.classList.toggle('show',!e[0].isIntersecting&&e[0].boundingClientRect.top<0)}).observe(buy);
  }

  // videos: solo corren cuando estan en pantalla
  if('IntersectionObserver' in window){
    var vo=new IntersectionObserver(function(es){es.forEach(function(e){e.isIntersecting?e.target.play().catch(function(){}):e.target.pause()})},{threshold:.25});
    $$('video[data-auto]').forEach(function(v){vo.observe(v)});
  }
})();

// carruseles que giran solos: resenas, galeria y colores. Se pausan 8 s cuando la persona los toca.
(function(){
  function auto(el,ms){
    if(!el||el.children.length<2) return;
    var t=null;
    function paso(){
      var a=el.children[0].getBoundingClientRect(), b=el.children[1].getBoundingClientRect();
      var w=b.left-a.left;
      if(el.scrollLeft+el.clientWidth>=el.scrollWidth-4) el.scrollTo({left:0,behavior:'smooth'});
      else el.scrollBy({left:w,behavior:'smooth'});
    }
    function start(){ if(!t) t=setInterval(paso,ms); }
    function stop(){ clearInterval(t); t=null; }
    var re=null;
    ['pointerdown','touchstart','wheel'].forEach(function(ev){ el.addEventListener(ev,function(){ stop(); clearTimeout(re); re=setTimeout(start,8000); },{passive:true}); });
    start();
  }
  document.querySelectorAll('.gal .slides').forEach(function(e){auto(e,4000)});
  // tiras continuas: se duplica el contenido para que el bucle no tenga corte, y se pausa mientras se toca
  document.querySelectorAll('.marq').forEach(function(m){
    var t=m.querySelector('.track'); if(!t) return;
    Array.prototype.slice.call(t.children).forEach(function(c){var k=c.cloneNode(true);k.setAttribute('aria-hidden','true');t.appendChild(k)});
    m.addEventListener('touchstart',function(){m.classList.add('pausa')},{passive:true});
    m.addEventListener('touchend',function(){m.classList.remove('pausa')},{passive:true});
  });
})();

/* Shopify: los botones de la landing abren Releasit; si aun no cargo, bajan al pedido */
(function () {
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href="#pedido"]');
    if (!a) return;
    var b = document.querySelector('#_rsi-buy-now-button-overwrite, #form-cod-embed ._rsi-buy-now-button, #_rsi-buy-now-button');
    if (b) { e.preventDefault(); b.click(); }
  });
  var pintar = function () {
    var b = document.querySelector('#form-cod-embed ._rsi-buy-now-button');
    if (b && b.style.getPropertyValue('background') !== 'rgb(226, 37, 44)') {
      b.style.setProperty('background', '#E2252C', 'important');
      b.style.setProperty('border-radius', '14px', 'important');
    }
  };
  new MutationObserver(pintar).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
  pintar();
})();
